<template>
  <van-tabbar v-model="active" @change="onChange">
    <!-- <van-tabbar-item @click="goHome">
            <template #icon="props">
                <div class="tabbar-item">
                    <img
                        :style="{
                            height: props.active ? '1.66rem' : '1.3rem',
                            marginBottom: props.active ? '0' : '3px'
                        }"
                        :src="
                            props.active
                                ? require('@images/common/home_selected.svg')
                                : require('@images/common/home.svg')
                        "
                    />
                    <span class="title" v-if="!props.active">首页</span>
                </div>
            </template>
        </van-tabbar-item> -->
    <!-- <van-tabbar-item replace to="/curriculum?showTabbar=0">
            <template #icon="props">
                <div class="tabbar-item">
                    <img
                        class="icon"
                        :src="
                            props.active
                                ? require('@images/common/course_selected.svg')
                                : require('@images/common/course.svg')
                        "
                    />
                    <span :class="['title', props.active ? 'active' : '']">视频课程</span>
                </div>
            </template>
    </van-tabbar-item>-->
    <van-tabbar-item @click="goStCommonwealth">
      <template #icon="props">
        <div class="tabbar-item">
          <img
            class="icon"
            :src="
              props.active
                ? require('@images/stCommonwealth/stCommonwealth.svg')
                : require('@images/stCommonwealth/no-stCommonwealth.svg')
            "
          />

          <span :class="['title', props.active ? 'active' : '']">首页</span>

          <!-- <span
                        :class="[number > 100 ? 'more-new-tip' : 'new-tip']"
                        v-if="number && isLogin"
                        >{{ number }}</span
                    > -->
        </div>
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace @click="goVideoMeeting" icon="search">
      <template #icon="props">
        <div class="tabbar-item">
          <img
            class="icon"
            :src="
              require(`@images/common/${
                props.active ? 'join_meeting_selected' : 'join_meeting'
              }.svg`)
            "
            v-if="!isOnceFlag"
          />
          <lottie :options="options" class="icon" @complete="completeVideo" v-if="isOnceFlag" />
          <span :class="['title', props.active ? 'active' : '']">视频会议</span>
        </div>
      </template>
    </van-tabbar-item>

    <!-- <van-tabbar-item @click="goOpeningPublicity">
      <template #icon="props">
        <div class="tabbar-item">
          <img
            class="icon"
            :src="
              props.active
                ? require('@images/common/open_selected.svg')
                : require('@images/common/open.svg')
            "
          />
          <span :class="['title', props.active ? 'active' : '']">科普创作</span>
        </div>
      </template>
    </van-tabbar-item> -->

    <van-tabbar-item replace @click="goMine">
      <template #icon="props">
        <div class="tabbar-item">
          <img
            class="icon"
            :src="
              props.active
                ? require('@images/common/mine_selected.svg')
                : require('@images/common/mine.svg')
            "
          />
          <span :class="['title', props.active ? 'active' : '']">我的</span>
          <span
            :class="[unreadCount > 100 ? 'more-new-tip' : 'new-tip']"
            v-if="unreadCount && isLogin"
            >{{ unreadCount }}</span
          >
        </div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import video from '@animation/video'
import Lottie from '@components/Lottie'
// import { Tabbar, TabbarItem } from 'vant'
import javaRequest from '@utils/request/javaRequest'
import { NativeMessageData, NativeMessagePush } from '@utils/nativeBridge/nativeMessage'
import router from '@/router'
import { mapGetters, mapState } from '@utils/vuex'

export default {
  components: {
    // Tabbar,
    // TabbarItem,
    Lottie
  },
  props: {},
  data() {
    return {
      active: 0,
      activeCache: 0,
      options: {
        loop: false,
        animationData: video
      },
      isOnceFlag: false,
      timer: null,
      from: ''
    }
  },
  computed: {
    ...mapState('messagePush', ['unreadCount', 'unreadMessages', 'quantity', 'waitNum']),
    ...mapState('home', ['collegeID']),
    ...mapState(['deptUnionId']),
    ...mapGetters(['currentTitle', 'isLogin']),
    tabbarSelectedIndex() {
      return this.$store.state.common.tabbarSelectedIndex
    },
    userInfos() {
      return this.$store.state.user.userInfos
    },
    tabbarCollege() {
      return this.$store.state.common.tabbarCollege
    },
    number() {
      console.log(
        '公告未读消息数：',
        Number(this.quantity),
        '顾问未读消息数：',
        Number(this.unreadMessages),
        '待接受',
        Number(this.waitNum)
      )
      return Number(this.quantity) + Number(this.unreadMessages) + Number(this.waitNum)
    }
  },
  watch: {
    tabbarSelectedIndex(info) {
      const isInfoObject = Object.prototype.toString.call(info) === '[object Object]'
      const { index, params } = isInfoObject ? info : { index: info }
      this.active = index

      const paths = [
        // '/',
        '/stCommonwealth',
        '/videoConferencing',
        // '/openingPublicity',
        '/personalCenter'
      ]
      if (paths[index] === this.$route.path) return
      if (index == 2) {
        this.autoHandleLogin(() => {
          this.$router.replace('/personalCenter')
        })
      } else if (index == 1) {
        this.autoHandleLogin(() => {
          //入会页面
          this.$router.replace({
            path: '/videoConferencing',
            query: params
          })
        })
      } else if (index == 4) {
        // this.$router.replace({
        //     path: '/openingPublicity',
        //     query: params
        // })
      } else if (index == 0) {
        this.$router.replace({
          path: '/stCommonwealth',
          query: params
        })
      }
    }
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.isOnceFlag = true
    }, 2000)
    this.$store.commit('home/setCollegeID', this.collegeID)
    // this.onChange()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.active = 0
        this.$router.replace({
          path: '/'
        })
      }
    },
    goStCommonwealth() {
      // if (this.isLogin) {
      this.active = 0

      this.$router.replace({
        path: '/stCommonwealth'
      })
      // } else {
      //     this.$router.push({
      //         path: '/login',
      //         query: {
      //             from: 'stCommonwealth'
      //         }
      //     })
      // }
    },
    goVideoMeeting() {
      this.autoHandleLogin(() => {
        this.active = 1

        this.$router.replace({
          path: '/videoConferencing'
        })
      })
    },
    goMine() {
      this.autoHandleLogin(() => {
        this.active = 2

        this.$router.replace({
          path: '/personalCenter'
        })
      })
    },
    //处理未登录和没有认证通过用户的跳转
    autoHandleLogin(func) {
      if (this.isLogin) {
        if (this.userInfos.isAuth) {
          func()
        } else {
          this.active = 0
          this.$toast('需要完成认证才可使用')
        }
      } else {
        this.$router.push({
          path: '/login',
          query: {
            from: 'stCommonwealth'
          }
        })
      }
    },
    goOpeningPublicity() {
      if (this.isLogin) {
        this.$store.dispatch('user/getUserInfos').then(res => {
          let { data } = res
          if (data.is_open_science_creation == 1) {
            this.$router.replace({
              path: `/doctorMainPage?doctor_id=${data.doctor_id}&showTabbar=0`
            })
          } else {
            if (
              data.apply_science_creation_status == 0 ||
              data.apply_science_creation_status == 3 ||
              data.apply_science_creation_status == 2
            ) {
              this.$router.replace({
                path: '/openingPublicity'
              })
            } else if (data.apply_science_creation_status == 1) {
              this.$router.replace({
                path: '/openingPublicitySuccess?showTabbar=0'
              })
            }
          }
        })
      } else {
        this.$router.replace({
          path: '/openingPublicity'
        })
      }
    },
    completeVideo() {
      console.log('complete', '-------')
      this.isOnceFlag = false
    },
    onChange(index) {
      console.log(index)
      this.$store.commit('clearKeepAlive', [])
      // if (index === 2) {
      // this.active = this.activeCache
      // this.$nativeBridge.sendMessage(
      //     new NativeMessagePush({
      //         pageName: 'meeting'
      //     })
      // )
      // } else {
      this.active = index
      this.activeCache = this.active
      // }
      // if (this.isLogin) {
      //     this.$store.dispatch('messagePush/getMessagePush', {
      //         pageNum: 1,
      //         pageSize: 20,
      //         messageRecordStatus: ''
      //     })
      // }

      if (this.isLogin) if (!this.userInfos.doctor_id) return
      if (this.isLogin) {
        this.$store
          .dispatch('getisDeptUnion', {
            doctorId: this.userInfos.doctor_id
          })
          .then(res => {
            if (res.result.total) {
              this.$store.commit('setdeptUnionId', res.result.records[0].id)
              this.$store.dispatch('messagePush/getUnreadQuantity', {
                doctorId: this.userInfos.doctor_id,
                deptUnionId: res.result.records[0].id
              })
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0 !important;
}

.van-tabbar {
  z-index: 0;
  border-top: 1px solid #ececec;
}
</style>

<style lang="scss" scoped>
@import '@styles/variables.scss';

.tabbar-item {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > .icon {
    height: 1.3rem;
    margin-bottom: 3px;
  }

  > .title {
    font-size: $fsmd;
    font-weight: 400;
    color: #222222;
  }

  > .title.active {
    color: #0089ff;
  }
  .new-tip {
    position: absolute;
    right: -0.32rem;
    top: 0.2rem;
    width: 0.64rem;
    height: 0.64rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5222d;
    border-radius: 100%;
    font-size: $fsxs;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .more-new-tip {
    position: absolute;
    right: -0.72rem;
    top: 0.2rem;
    width: 1.07rem;
    height: 0.64rem;
    background: #f5222d;
    border-radius: 1.28rem;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: $fsxs;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
